import { createUrlFromSurveyName } from "../../../utils";
import { GenerateButton, Input, Label, LabelContainer } from "./styles";

export default function SlugInput({ surveyTitle, slug, onChangeSlug = () => null }) {
  return (
    <Label>
      <LabelContainer>
        <span>URL</span>
        <GenerateButton
          title="Gera a URL a partir do título"
          onClick={() => onChangeSlug(createUrlFromSurveyName(surveyTitle))}
        >
          Gerar URL do título
        </GenerateButton>
      </LabelContainer>
      <Input
        type="text"
        placeholder="Ex: url-de-exemplo"
        value={slug}
        onChange={(e) => onChangeSlug(e.target.value)}
      />
    </Label>
  );
}
